import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import langMsg from '@blade-sxp/search-center/lang/index';
import Popover from './popover.vue';
import deviceSelect from '@blade/common/components/device-group-cascader-select/index.vue';
import { fromPage } from '@blade-sxp/search-center/interfaces/enum';
import routePage from '@blade-sxp/search-center/pages/components/result/components/routePage.vue';
import routeGis from '@blade-sxp/search-center/pages/components/result/components/route-gis.vue';
import propertyRetrieval from '@blade-sxp/search-center/pages/components/result/components/property-retrieval.vue';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import { AccountModule } from '@blade-sxp/account/store/account';
import datePickers from '@blade/common/components/date-time-select/index.vue';
import moment from 'moment';
let AlarmCenter = class AlarmCenter extends Vue {
    show;
    imageName;
    allNum;
    isClose;
    routeType;
    deviceNames;
    langeName;
    imagePage;
    default;
    linkList;
    tagIndex;
    form = {
        dates: [moment().subtract('days', 1).format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')],
        eventTypes: [],
        device: [],
    };
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    routeDialogVisible = false;
    tagList = []; // 滚动展示tab
    checkindex = 0;
    isCheck = false; // 是否可选轨迹
    defaultTime = ['00:00:00', '23:59:59'];
    maxHeight = 110; // 滚动顶部高度
    // maxHeight: Number = 203;
    eventPage = fromPage.EVENT_PAGE;
    routeImageUrl = require('@blade-sxp/search-center/assets/images/route.png');
    labelList = [];
    get mapType() {
        return AccountModule.accountInfo?.mapType;
    }
    // 轨迹ID删除 同步页面
    changeIdempotentId(imageId) {
        this.$emit('track', imageId);
    }
    dataFilter(node, val) {
        if (!!~node.text.indexOf(val) || !!~node.text.toUpperCase().indexOf(val.toUpperCase())) {
            return true;
        }
    }
    getTypeValue(val) {
        let newArr = val.slice(-1);
        if (newArr[0] === 'null') {
            newArr = [];
        }
        return newArr;
    }
    changeTypes(val) {
        let filterEventType = this.getTypeValue(val || []);
        this.$emit('event', filterEventType);
        this.tagData();
    }
    clearAllTrack() {
        this.$refs.propver.clearAlltrack();
    }
    deviceIdRest(val) {
        this.$emit('deviceId-rest', val);
        this.form.device = val;
    }
    onLabelChange(val) {
        if (val.length === 1 && this.labelList[0] === val[0].label) {
            this.labelList = [];
            return;
        }
        this.labelList = [];
        val.forEach((item) => {
            this.labelList.push(item.data.label);
        });
        this.tagData();
    }
    // 点击切换顶部
    tagShow() {
        this.$emit('filter');
    }
    pickerOptions(time) {
        this.$emit('pickerTime', time ?? this.form.dates);
        this.tagData();
    }
    route() {
        this.isCheck = !this.isCheck;
        this.$emit('is-check', this.isCheck);
    }
    deletedNum(trackNum, item) {
        this.$emit('trackNum', trackNum, item);
        // 打开routepage弹框
    }
    tagData() {
        this.tagList = [];
        if (!this.labelList) {
            this.labelList = [];
        }
        if (this.labelList.length > 1) {
            this.labelList = [`${this.$t('multiple')}`];
        }
        const label = this.$refs.cascaderList.getCheckedNodes()[0].pathLabels;
        if (this.form.dates[0] !== '') {
            this.tagList.push(label.toString(), String(this.labelList), String(this.form.dates));
        }
    }
    gotoRoutePage() {
        this.routeDialogVisible = true;
    }
    mounted() {
        window.addEventListener('scroll', this.handleScrollx, true);
    }
    handleScrollx(e) {
        const elm = e.target;
        if (elm?.className === 'main-container') {
            this.$refs.datePicker.pickerVisible = false;
            this.$refs.cascader.$children[0].$children[0].dropDownVisible = false;
            this.$refs.cascaderList.$children[0].$children[0].dropDownVisible = false;
            // (this.$refs.propertyRetrieval as HTMLFormElement).$children[1].$children[0].$children[0].dropDownVisible = false;
        }
    }
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScrollx, true);
    }
};
__decorate([
    Prop()
], AlarmCenter.prototype, "show", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "imageName", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "allNum", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "isClose", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "routeType", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "deviceNames", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "langeName", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "imagePage", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "default", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "linkList", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "tagIndex", void 0);
AlarmCenter = __decorate([
    Component({
        name: 'FilterBar',
        components: { Popover, deviceSelect, routePage, BlurPicture, routeGis, propertyRetrieval, datePickers },
        i18n: {
            sharedMessages: langMsg,
        },
    })
], AlarmCenter);
export default AlarmCenter;
